import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useRef, useState } from 'react';
import numeral from 'numeral';
import classnames from 'classnames';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import AddVideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import { scaleToSize } from '../../_helpers';
import ZoomModal from '../Image/ZoomModal';
import { useFullview } from '../Image/hooks/useFullview';
import extStyle from '../Image/ImageFullview.scss';
const ImageAttachment = ({ width, height, attachment, isPublished = false, isZoomed, onEnterZoomMode, onExitZoomMode })=>{
    const imgRef = useRef(null);
    const [playButtonShown, setPlayButtonShown] = useState(true);
    const { previewFile, srcFile, isFullscreen, isPixel, canZoom, src, srcSet, sizes, isLargeGif } = useFullview({
        stageWidth: width !== null && width !== void 0 ? width : 0,
        stageHeight: height !== null && height !== void 0 ? height : 0,
        source: attachment,
        isPublished
    });
    const handleClick = useCallback((e)=>{
        if (isLargeGif && imgRef.current && playButtonShown) {
            imgRef.current.srcset = ''; // force the src to show
            setPlayButtonShown(false);
            return;
        }
        if (canZoom && onEnterZoomMode) {
            // This is for INP purposes
            if (imgRef.current) {
                imgRef.current.style.opacity = '0.8';
            }
            yieldToMain(()=>{
                onEnterZoomMode();
            });
        }
    }, [
        canZoom,
        isLargeGif,
        onEnterZoomMode,
        playButtonShown
    ]);
    const handleCloseZoom = useCallback(()=>{
        if (imgRef.current) {
            imgRef.current.style.opacity = '1';
        }
        onExitZoomMode && onExitZoomMode();
    }, [
        onExitZoomMode
    ]);
    if (!previewFile || !srcFile) {
        return null;
    }
    const size = scaleToSize(previewFile, {
        width,
        height
    });
    const wrapperSeoProps = {
        typeof: 'ImageObject',
        vocab: 'https://schema.org/'
    };
    const imgExtraProps = {
        property: 'contentUrl',
        fetchPriority: 'high'
    };
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: classnames(extStyle['root'], isFullscreen && extStyle['fullscreen']),
        style: {
            width,
            height
        }
    }, wrapperSeoProps), isZoomed && srcFile && /*#__PURE__*/ React.createElement(ZoomModal, {
        src: srcFile.src,
        srcSet: getSrcSet(attachment),
        width: srcFile.width,
        height: srcFile.height,
        isPixel: !!isPixel,
        onClose: handleCloseZoom
    }), isLargeGif && playButtonShown && /*#__PURE__*/ React.createElement("div", {
        className: extStyle['gif-player'],
        style: size
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: AddVideoIcon,
        size: 'large',
        onClick: handleClick
    }, "Play Gif"), /*#__PURE__*/ React.createElement("div", null, "Play large GIF (", numeral(srcFile.filesize).format('0.00b'), ")")), /*#__PURE__*/ React.createElement("img", _object_spread({
        key: `fv-${attachment.fileId}`,
        ref: imgRef,
        alt: 'Attachment',
        "aria-hidden": "true",
        className: classnames(extStyle['image'], isPixel && extStyle['pixel'], canZoom && extStyle['zoomable']),
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        style: size,
        onClick: handleClick
    }, imgExtraProps)));
};
ImageAttachment.displayName = 'ImageAttachment';
export default ImageAttachment;

//# sourceMappingURL=ImageAttachment.js.map